import {
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  effect,
  inject,
  signal,
} from '@angular/core';
import { TranslatePipe } from '../../i18n';
import { ZipService } from '../zip.service';

@Component({
  selector: 'app-zip-info',
  imports: [TranslatePipe],
  templateUrl: './zip-info.component.html',
  styleUrl: './zip-info.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ZipInfoComponent {
  #zipService = inject(ZipService);

  readonly fileName = this.#zipService.fileName;

  readonly isFinished = this.#zipService.isFinished;

  readonly progress = computed(() => {
    if (this.#zipService.status() === 'downloading') {
      return this.#zipService.downloadProgress();
    }

    return this.#zipService.zipProgress();
  });

  readonly status = this.#zipService.status;

  readonly showInfo = signal(false);

  constructor() {
    effect(() => {
      const status = this.status();

      switch (status) {
        case 'finished':
          setTimeout(() => {
            this.showInfo.set(false);
          }, 5000);
          break;
        case 'downloading':
        case 'zipping':
          this.showInfo.set(true);
          break;
        default:
          this.showInfo.set(false);
      }
    });
  }

  onCancel() {
    this.#zipService.cancelDownload();
  }
}
